import { z } from 'zod';
import { BackgroundColors } from '../colors';
export const zTrackColor = z
    .string()
    .nullable()
    .refine((v) => v === null || BackgroundColors.includes(v), { message: 'invalidTrackColor' });
/** Shared input for create: source of truth for `plan.createTrack` (tRPC) and the `track.create` Zero mutator (which extends it with `teamId`). */
export const zCreateTrackInput = z.object({
    id: z.uuid(),
    name: z.string(),
    parentTrackId: z.uuid().optional(),
    athletes: z.object({ id: z.uuid(), profileId: z.uuid() }).array(),
    color: zTrackColor.optional().default(null),
});
/** Shared input for edit: `athleteIds` is the desired member set, reconciled against existing rows. Zero mutator extends it with `teamId`. */
export const zEditTrackInput = z.object({
    id: z.uuid(),
    name: z.string(),
    athleteIds: z.uuid().array(),
    color: zTrackColor,
});
/** Shared input for delete: source of truth for `plan.deleteTrack` (tRPC) and the `track.delete` Zero mutator (which extends it with `teamId`). */
export const zDeleteTrackInput = z.object({
    trackId: z.uuid(),
});
/** Shared input for archive/unarchive: source of truth for `plan.archiveTrack` / `plan.unarchiveTrack` (tRPC) and the `track.archive` / `track.unarchive` Zero mutators (which extend it with `teamId`). Same shape for both directions — only the resulting `archivedAt` value differs. */
export const zArchiveTrackInput = z.object({
    trackId: z.uuid(),
});
/** Shared input for moving a sub-track to a different parent: source of truth for `plan.moveSubTrack` (tRPC) and the `track.move` Zero mutator. `teamId` scopes the move — both tracks must belong to it. */
export const zMoveSubTrackInput = z.object({
    trackId: z.uuid(),
    destinationTrackId: z.uuid(),
    teamId: z.uuid(),
});
/**
 * Why a move was refused, machine-readable. The client picks its copy from the
 * reason instead of matching the message text: the message is English-only and
 * free to be reworded, so a match on it would silently change what a coach
 * reads. `message` stays for logs, and for any caller with no copy for a
 * reason.
 */
export const moveSubTrackRejectionReasons = [
    'TRACK_NOT_FOUND',
    'NOT_A_SUB_TRACK',
    'DESTINATION_NOT_FOUND',
    'DESTINATION_NOT_A_PARENT',
    'ALREADY_ON_DESTINATION',
    'DESTINATION_NAME_TAKEN',
];
/**
 * Narrows an untrusted value — a reason off either transport's error payload —
 * to a reason this build knows. An older client meeting a newer server's
 * reason must fall back, not mis-read it.
 */
export function isMoveSubTrackRejectionReason(value) {
    return (typeof value === 'string' &&
        moveSubTrackRejectionReasons.includes(value));
}
//# sourceMappingURL=track.js.map